import React from "react";

import { MDBRow, MDBCol, MDBContainer } from "mdbreact";

import Navbar from "../components/Navbar";
import Logo from "../components/Logo";
import Whatsapp from "../components/Whatsapp";
import Sale from "../components/Sale";
import NewProject from "../components/NewProject";
import Project from "../components/Project";
import AboutUs from "../components/AboutUs";
import Service from "../components/Service";
import Contact from "../components/Contact";

import "./styles.css";

const Home = () => {
    const handleClickScroll = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <MDBContainer fluid className="container-home w-100 p-0">
            {/* Whatsapp flotante */}
            <Whatsapp />

            {/* Overlay */}
            <MDBRow className="overlay"></MDBRow>

            {/* Imagen de fondo */}
            <MDBRow
                className="img"
                style={{
                    backgroundImage: "url(/images/house.jpg)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    width: "100%",
                    minHeight: "500px", // ajusta según necesites
                }}
            ></MDBRow>

            <MDBRow className="position-relative mx-0">
                {/* Navbar */}
                <MDBCol sm="12" className="px-0">
                    <Navbar />
                </MDBCol>

                {/* Botones de proyectos destacados */}
                <MDBCol sm="12" className="featured-buttons-wrapper px-3">
                    <div className="featured-buttons-row">
                        <div className="featured-button-col">
                            <button
                                type="button"
                                className="btn btn-lg btn-featured-ebenezer5 featured-button"
                                style={{ fontSize: 17, fontWeight: "bold", borderRadius: 15 }}
                                onClick={() => handleClickScroll("new_project_ebenezer5")}
                            >
                                NUEVO PROYECTO EBENEZER V
                                <br />
                                APARTAMENTOS DESDE: $300'000.000 (51,66m²) Hasta: $525'187.500 (83,8m²)
                                totalmente terminados, ascensor, con disponibilidad de parqueadero.
                                <br />
                                <br />
                                Para más información de clic sobre este mensaje
                            </button>
                        </div>

                        <div className="featured-button-col">
                            <button
                                type="button"
                                className="btn btn-lg btn-featured-ebenezer6 featured-button"
                                style={{ fontSize: 17, fontWeight: "bold", borderRadius: 15 }}
                                onClick={() => handleClickScroll("new_project_ebenezer6")}
                            >
                                NUEVO PROYECTO EBENEZER VI
                                <br />
                                Apartamentos de $290'000,000 (50,72m²) hasta $360'000,000 (54,31m²) totalmente terminados,
                                ascensor y parqueadero incluido en el precio.
                                <br />
                                Locales comerciales de 35m² hasta 65m² desde $267'000.000.
                                <br />
                                <br />
                                Para más información de clic sobre este mensaje
                            </button>
                        </div>
                    </div>
                </MDBCol>

                {/* Logo */}
                <MDBCol sm="12" className="px-0">
                    <Logo />
                </MDBCol>

                {/* Secciones de la página */}
                <MDBCol sm="12" className="px-0">
                    <Sale />
                </MDBCol>
                <MDBCol sm="12" className="px-0">
                    <NewProject />
                </MDBCol>
                <MDBCol sm="12" className="px-0">
                    <Project />
                </MDBCol>
                <MDBCol sm="12" className="px-0">
                    <AboutUs />
                </MDBCol>
                <MDBCol sm="12" className="px-0">
                    <Service />
                </MDBCol>
                <MDBCol sm="12" className="px-0">
                    <Contact />
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
};

export default Home;
